import React, { useEffect, useState } from 'react'
import RouteModal from '../../../Component/BasicComponents/Modal/RouteModal'
import { Btn } from '../../../AbstractElements'
import CustomInput from '../../../Component/BasicComponents/CustomInput';
import MultiSelectDropdown from '../../../Component/BasicComponents/Dropdowns/MultiSelectDropdown';
import { useGetOrgUnitsData } from '../../Employee/hooks/useEmployee';
import { useAddSurveyCategory, useUpdateSurveyCategory } from '../hook/useSurveryCategory';
import { useSurveyConfiguration } from '../hook/useSurvey';
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import PaginatedRouteDropdown from '../../../Component/BasicComponents/Dropdowns/PaginatedDropdownWrapper';
import { showToast } from '../../../utils/toastUtils';

interface CategoryRowDataInterface{
  SurveyCatName?: string;
  Orgunitid?: string;
  SurveyCatid?: number;
  SurveyFor?: string;
  Status?: string;
  IsForDcr?: boolean | null;
}
type ProductCardProps = {
    setIsModalOpen?: any;
    isModalOpen?: any;
    toggleModal?: any;
    title?: any;
    checkAddEditStatus?: any;
    setCheckAddEditStatus?: any;
    handleSubmit?: any;
    CategoyRowData?:CategoryRowDataInterface
};

const CategoryAddAndEditModal: React.FC<ProductCardProps> = ({CategoyRowData, setIsModalOpen, isModalOpen, title, checkAddEditStatus, setCheckAddEditStatus }) => {
   
    useEffect(()=>{
        if(checkAddEditStatus ==='Edit'){
            const orgInitalData = CategoyRowData?.Orgunitid?.split(',');
            // const FilterInitalData =  formatedData.filter((item)=>{
            //     return (
            //        orgInitalData?.includes(item.id)
            //     )
            // })
              setCategoryName(String(CategoyRowData?.SurveyCatName));
              setSelectOrgUnit(orgInitalData);
              setSurveyFor(String(CategoyRowData?.SurveyFor));
        }

        if(checkAddEditStatus ==='Add'){
            setSelectOrgUnit([])
            setCategoryName('')
            setSurveyFor('')
        }

    },[checkAddEditStatus,CategoyRowData,])


   const [selectOrgUnit, setSelectOrgUnit] = useState<any>([])
   const [CategoryName,setCategoryName] = useState('');
   const [SurveyFor,setSurveyFor]  = useState('');

   const {data,isLoading,isSuccess}= useGetOrgUnitsData({enable:true})
   const {mutate:addSurveyCategory} = useAddSurveyCategory();
   const {mutate:updateSurveyCatrgory} = useUpdateSurveyCategory()   

    const {data:surveyConfig,isLoading:SurveyConfigIsLoading,isSuccess:SurveConfigIsSuccess} = useSurveyConfiguration({enable:true});
    // console.log('surveyConfig------------->',surveyConfig?.formatedData_SurveyFor); 
  
   const formatedData = Array.isArray(data?.data)?
   data?.data.slice(1).map((item:any)=>({
   id:Number(item.id),
   label:String(item.label)
   })):[]
   
   const handleInput =(e:any)=>{
    const input:any = e.target.value;
    setCategoryName(input);
   }
   

    
  const handleSubmit = (e:React.FormEvent<HTMLFormElement>)=>{
             e.preventDefault();

             if(checkAddEditStatus ==='Add' && selectOrgUnit.length >0){
                const OrgunitArray = selectOrgUnit?.map((item:any)=>Number(item))
                const ReqBody ={
                    SurveyCatName:String(CategoryName),
                    Orgunitid:OrgunitArray,
                    SurveyFor:SurveyFor === ''? null :SurveyFor
                    // SurveyFor:null
                }
               addSurveyCategory(ReqBody);
              setIsModalOpen(false);
              setCategoryName('');
              setSurveyFor('');
              setSelectOrgUnit([]);
             }

            if(checkAddEditStatus === 'Edit'){
                const OrgunitArray = selectOrgUnit?.map(Number);
                console.log('OrgunitArray',OrgunitArray);

               if(!OrgunitArray || OrgunitArray.length === 0 || OrgunitArray.some(isNaN)) {
               showToast.warning('Select Org org unit');
                return;
                }
                const ReqBody={
                      SurveyCatName:CategoryName,
                      Orgunitid:OrgunitArray,
                      SurveyFor:SurveyFor,
                      Status:Number(CategoyRowData?.Status)
                }
        
            updateSurveyCatrgory({ReqBody:ReqBody,id: Number(CategoyRowData?.SurveyCatid)});
            setIsModalOpen(false);
            // setCategoryName('');
            // setSurveyFor('');
            // setSelectOrgUnit([]);
            }
  }
const handleCancil=()=>{

     setIsModalOpen(false);
     setSelectOrgUnit([]);
     setCheckAddEditStatus('');
     setSurveyFor('');
     setCategoryName('')
}

    return (
        <RouteModal
            isOpen={isModalOpen}
            toggle={() => { 
                if(checkAddEditStatus =='Edit'){
                    setIsModalOpen(!isModalOpen);
                }else{
                    setIsModalOpen(!isModalOpen);
                    setSelectOrgUnit([]);
                    setCategoryName('');
                    setSurveyFor('');
                }
            }}
            title={title}
            size="sm"
            content={
                <form onSubmit={handleSubmit}>
                    <div className="row mb-0">
                        <CustomInput
                            placeholder="Name"
                            disabled={false}
                            onChange={handleInput}
                            // value={CategoryName }
                            value={CategoryName}
                            required={true}
                            asterisk
                            label="Category Name"
                            style={{
                                border: "1px solid #e0e0e0",
                                borderRadius: "4px",
                                padding: "10px",
                                fontSize: "14px",
                            }}
                        />
                        {/* <label>Org Unit*</label> */}

                        <ReusableDropdown 
                        isMulti={true}
                        options={(formatedData) ||[]}
                        value={selectOrgUnit}
                        asterisk
                        onChange={(value: any) =>{
                            console.log('value',value);
                            setSelectOrgUnit(value);
                        }}
                        DropdownHeading="Org Unit"
                        />
                        {/* <MultiSelectDropdown
                            // disable={!vissibleSaveButton}
                            placeHolder="Select"
                            data={
                                formatedData ||
                                [
                                    { id: 1, name: 'test1' },
                                    { id: 2, name: 'test2' },
                                    { id: 3, name: 'test3' },

                                ]}
                            selectedNames={selectOrgUnit}
                            setSelectedNames={setSelectOrgUnit}
                        /> */}
                      <ReusableDropdown 
                      options={(!SurveyConfigIsLoading && SurveConfigIsSuccess && surveyConfig?.formatedData_SurveyFor) ||[]}
                      value={SurveyFor}
                      onChange={(value: any) =>setSurveyFor(value)}
                      DropdownHeading="Survey For"
                      />

                        <div style={{ height: 10, marginTop:'10px'}} />
                        <div className="d-flex justify-content-start gap-2">
                            <Btn
                                style={{ backgroundColor: "#43B9B2", color: "white" }}
                                type="submit"
                            >
                                {checkAddEditStatus === 'Add' ? 'Submit' : 'Update'}
                            </Btn>
                            <Btn
                                style={{
                                    backgroundColor: "#F9FAFC",
                                    color: "#000",
                                    border: "1px solid #E0E0E0",
                                }}
                                type="button"
                                onClick={() =>handleCancil()}>
                                Cancel
                            </Btn>
                        </div>
                    </div>
                </form>
            }
        />
    )
}

export default CategoryAddAndEditModal